
import Logistics from "@/store/modules/system/logistics/entity";
import { Component, Mixins, ActionButtonConfig, FormModalMixins } from "@/lib";
import { systemConst } from "@/lib/consts/modules/system";
@Component
export default class EditLogistics extends Mixins(FormModalMixins) {
  model = new Logistics();
  created() {
    Object.assign(this.config, { modelTitleL: "Action.Edit", labelWidth: 150, okAction: "system/logistics/update" });
  }
  get record() {
    return this.$store.state.system.logistics.editLogistics;
  }
}
